import React, { useEffect, useState } from "react";
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from "../../components/ui/card";
import {
	Table,
	TableBody,
	TableCaption,
	TableCell,
	TableFooter,
	TableHead,
	TableHeader,
	TableRow,
} from "../../components/ui/table";
import { Button } from "../../components/ui/button";
import { cn, convertToCSV, generateSecurePassword } from "../../lib/utils";
import { Calendar } from "../../components/ui/calendar";
import { CalendarIcon, ChevronsUpDown, Check, Download } from "lucide-react";
import { format, isValid, parseISO } from "date-fns";
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
} from "../../components/ui/command";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "../../components/ui/popover";

import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "../../components/ui/sheet";
import { useMutation, useQuery } from "react-query";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useLocation, useNavigate } from "react-router-dom";
import { filter } from "lodash";
import { useToast } from "../../components/ui/use-toast";
import { ClipLoader } from "react-spinners";
import SsccModal from "../../components/SsccModal";
import Paginator from "../../components/Paginator";
import { useSelector } from "react-redux";

import { saveAs } from "file-saver";
import { ZipWriter, BlobWriter, TextReader } from "@zip.js/zip.js";
import useAuth from "../../hooks/useAuth";
import { sendToEmail } from "../../apis/api";
import {
	useCheckClientProducts,
	useGetClientProducts,
} from "../../migration-api/api-hooks/clients";
import {
	useDownloadSSCCLabel,
	useGetSSCCLabelTable,
} from "../../migration-api/api-hooks/labels";
import { useDispatch } from "react-redux";
import { setClients } from "../../store/features/clientSlice";

let staticDB = [];
function Sscc() {
	const { auth } = useAuth();
	const [startdate, setSatrtdate] = useState();
	const [enddate, setEndddate] = useState();
	const [openclient, setOpenClient] = useState(false);
	const [valueClient, setClientValue] = useState("");
	const [traceId, setTraceId] = useState("");
	const [selectedClientId, setSelectedClientId] = useState();
	const [elemTarget, setElemTarget] = useState(null);
	const [pageCount, setPageCount] = useState(0);
	const [openProd, setOpenProd] = useState(false);
	const [prodValue, setProdValue] = useState("");
	const dispatch = useDispatch();

	//

	const axiosPrivate = useAxiosPrivate();
	const { allClients } = useSelector((state) => state.clients);
	const navigate = useNavigate();
	const [eventList, setEventList] = useState([]);
	//   const [prods, setProds] = useState([])
	const [currentPage, setCurrentPage] = useState(1);
	const { toast } = useToast();
	const [page, setPage] = useState(1);
	const {} = useCheckClientProducts({});

	// Fetch products for selected client
	const { data: clientProductsData, isLoading: isLoadingProducts } =
		useGetClientProducts(selectedClientId, { enabled: !!selectedClientId });
	const prods = clientProductsData?.data || [];

	const {
		data: ssccLabelTable,
		isLoading: ssccLabelTableLoading,
		refetch,
	} = useGetSSCCLabelTable({
		clientIds: "all",
		prodIds: "all",
		startdate,
		enddate,
		currentPage: page,
	});

	const rows = ssccLabelTable?.rows || [];
	const total = ssccLabelTable?.total || 0;
	const pageCounts = ssccLabelTable?.pageCount || 0;
	const clientNames = rows.map((client) => client);

	const handleClientChange = (client) => {
		setClientValue(client.clientName);
		setSelectedClientId(client.id);
		setOpenClient(false);
		// Reset product selection when client changes
		setProdValue("");
	};

	const header = [{ field: "elementString", key: "elementString" }];

	const { download, isLoading } = useDownloadSSCCLabel({
		onSuccess: (blob) => {
			toast({
				variant: "success",
				title: "Download Started",
				description: "Your SSCC label download has started.",
			});
			downloadCSVAsEncryptedZip(blob);
		},
		onError: () => {
			toast({
				variant: "destructive",
				title: "Error",
				description: "There was an error downloading the SSCC label.",
			});
		},
	});

	const handleDownload = () => {
		if (
			traceId !== "" &&
			selectedClientId !== undefined &&
			selectedClientId !== null &&
			selectedClientId !== ""
		) {
			download({ traceId, clientId: selectedClientId });
		} else {
			toast({
				variant: "destructive",
				title: "Missing selection",
				description: "Please select a record before downloading.",
			});
		}
	};

	function handleParams() {
		const dateEnd =
			enddate !== undefined
				? format(enddate, "yyyy-MM-dd hh:mm:ss")
				: format(new Date(), "yyyy-MM-dd hh:mm:ss");
		const dateStart =
			startdate !== undefined
				? format(startdate, "yyyy-MM-dd hh:mm:ss")
				: new Date("2022-01-01");
		const clients = allClients?.map((client) => client.clientName);
		const prods = staticDB?.map((prod) => prod.prodName);
		const filterArry = filter(staticDB, (x) => {
			return (
				(valueClient === ""
					? clients.includes(x.clientName)
					: valueClient === x.clientName.toLowerCase()) &&
				(prodValue === ""
					? prods.includes(x?.prodName)
					: prodValue === x.prodName) &&
				new Date(x.createdAt).getTime() >=
					new Date(dateStart).getTime() &&
				new Date(x.createdAt).getTime() <= new Date(dateEnd).getTime()
			);
		});
		setEventList(filterArry);
	}

	const onPageChange = (page) => {
		setCurrentPage(page);
	};

	useEffect(() => {
		if (rows?.length) {
			dispatch(setClients(clientNames));
			setEventList(rows);
			staticDB = rows;
			setPageCount(pageCounts);
			//   setProds(staticDB)
		}
	}, []);

	const [longitude, setLongitude] = useState();
	const [latitude, setLatitude] = useState();
	const location = useLocation();

	useEffect(() => {
		navigator.permissions.query({ name: "geolocation" }).then((resp) => {
			//   console.log('geting location ......................')
			console.log(resp);
			if (resp.state === "granted" || resp.state === "prompt") {
				// console.log('granted')
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			} else if (resp.state === "denied") {
				navigate("/", { state: { from: location, replace: true } });
			}
		});

		function success(position) {
			setLatitude(`${position.coords.latitude}`);
			setLongitude(`${position.coords.longitude}`);
			console.log(position.coords.latitude);
		}

		function error(err) {
			console.log(err);
			navigate("/", { state: { from: location, replace: true } });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function handleDate(date) {
		if (date == null) return "N/A";
		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
		if (isValid(validDate))
			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
		return "N/A";
	}

	const sendPassword = useMutation((payload) => sendToEmail(payload), {
		onSuccess(variables, context) {
			toast({
				variant: "success",
				title: "Password Sent",
				description: `the password of the downloaded sscc file has been sent to your email`,
			});
		},

		onError(error) {
			if (error.code === "ERR_NETWORK") {
				console.log(error);
			} else if (
				error.response?.status === 403 ||
				error.response?.status === 401
			) {
				navigate("/", { state: { from: location }, replace: true });
			} else {
				toast({
					variant: "destructive",
					title: "Error",
					description: `${error?.response?.data?.message}`,
				});
			}
		},
	});

	async function downloadCSVAsEncryptedZip(fileBlob) {
		const password = generateSecurePassword();

		const zipWriter = new ZipWriter(new BlobWriter("application/zip"), {
			password,
			encryptionStrength: 1,
			zipCrypto: true,
		});

		let jsonText = await fileBlob.text();
		let parsed;

		try {
			parsed = JSON.parse(jsonText);
		} catch (e) {
			console.error("Failed to parse JSON:", jsonText);
			toast({
				title: "Download error",
				description: "Invalid file received from server",
				variant: "destructive",
			});
			return;
		}

		console.log("PARSED RESPONSE:", parsed);

		// 🟢 Extract real data safely
		let records = [];

		if (Array.isArray(parsed)) {
			records = parsed;
		} else if (Array.isArray(parsed.data)) {
			records = parsed.data;
		} else if (parsed.data) {
			// single object case
			records = [parsed.data];
		} else {
			console.error("No usable data in response:", parsed);
			toast({
				title: "Download error",
				description: "No data found in file",
				variant: "destructive",
			});
			return;
		}

		// 🔁 Now convert safely
		const csvString = convertToCSV(records, header);

		// 🔐 Add to encrypted zip
		await zipWriter.add(
			`encoded-sscc-${traceId}-sproxil.csv`,
			new TextReader(csvString),
			{ password },
		);

		const zipBlob = await zipWriter.close();

		// 🔽 Download zip
		saveAs(zipBlob, `encoded-sscc-${traceId}.zip`);

		sendPassword.mutate({
			emailTo: auth?.user?.email,
			subject: "SSCC File Password",
			html: `<html><body><p>your password for the sscc file you just downloaded is:</p> <h2>${password}</h2></body></html>`,
		});

		// 🧹 Reset UI
		setTraceId("");
		setSelectedClientId(undefined);
		setElemTarget(null);
	}

	return (
		<div className=" overflow-x-hidden">
			<Card className=" overflow-x-hidden">
				<CardHeader>
					<CardTitle className="my-[10px] flex justify-between items-center p-[20px]">
						{" "}
						<span className=" flex gap-[20px] items-center">
							<span>SSCC Generation Tab</span>
							<span>
								{" "}
								<Sheet>
									<SheetTrigger asChild>
										<Button variant="outline">
											Generate Label
										</Button>
									</SheetTrigger>
									<SheetContent className=" min-w-[550px]">
										<SheetHeader>
											<SheetTitle>
												Generate Label
											</SheetTitle>
											<SheetDescription>
												Enter the required SSCC details
												here. Click submit when you're
												done.
											</SheetDescription>
										</SheetHeader>
										<SsccModal
											longitude={longitude}
											latitude={latitude}
										/>
									</SheetContent>
								</Sheet>
							</span>
						</span>
						<span>
							<Button
								onClick={handleDownload}
								disabled={isLoading}
							>
								{isLoading ? (
									<ClipLoader color="primary" size={20} />
								) : (
									<Download />
								)}
							</Button>
						</span>
					</CardTitle>
					<CardDescription className="flex gap-[10px]">
						<Popover open={openclient} onOpenChange={setOpenClient}>
							<PopoverTrigger asChild>
								<Button
									variant="outline"
									role="combobox"
									aria-expanded={openclient}
									className="w-[200px] justify-between"
								>
									{valueClient
										? valueClient
										: "Pick a client..."}
									<ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
								</Button>
							</PopoverTrigger>
							<PopoverContent className="w-[200px] p-0">
								<Command>
									<CommandInput placeholder="Search client..." />
									<CommandEmpty>
										No Client found.
									</CommandEmpty>
									<CommandGroup>
										{allClients?.map((client) => (
											<CommandItem
												key={client.id}
												className="my-1"
												value={client?.clientName}
												onSelect={() =>
													handleClientChange(client)
												}
												// onSelect={currentValue => {
												//   setClientValue(currentValue)
												//   handleChange(client.key)
												//   setOpenClient(false)
												// }}
											>
												<Check
													className={cn(
														"mr-2 h-4 w-4",
														valueClient ===
															client?.clientName
															? "opacity-100"
															: "opacity-0",
													)}
												/>
												{client.clientName}
											</CommandItem>
										))}
									</CommandGroup>
								</Command>
							</PopoverContent>
						</Popover>

						<Popover open={openProd} onOpenChange={setOpenProd}>
							<PopoverTrigger asChild>
								<Button
									variant="outline"
									role="combobox"
									aria-expanded={openProd}
									className="w-[200px] justify-between"
								>
									{prodValue
										? prods.find(
												(prod) =>
													prod.prodName === prodValue,
											)?.prodName
										: "Pick a product..."}
									<ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
								</Button>
							</PopoverTrigger>
							<PopoverContent className="w-[200px] p-0">
								<Command>
									<CommandInput placeholder="Search product..." />
									<CommandEmpty>
										No product found.
									</CommandEmpty>
									<CommandGroup>
										{prods?.map((prod, index) => (
											<CommandItem
												key={index}
												className="my-1"
												value={prod.prodName}
												onSelect={(currentValue) => {
													setProdValue(currentValue);
													setOpenProd(false);
												}}
											>
												<Check
													className={cn(
														"mr-2 h-4 w-4",
														prodValue ===
															prod.prodName
															? "opacity-100"
															: "opacity-0",
													)}
												/>
												{prod.prodName}
											</CommandItem>
										))}
									</CommandGroup>
								</Command>
							</PopoverContent>
						</Popover>
						<Popover>
							<PopoverTrigger asChild>
								<Button
									variant={"outline"}
									className={cn(
										"w-[280px] justify-start text-left font-normal",
										!startdate && "text-muted-foreground",
									)}
								>
									<CalendarIcon className="mr-2 h-4 w-4" />
									{startdate ? (
										format(startdate, "PPP")
									) : (
										<span>Start date</span>
									)}
								</Button>
							</PopoverTrigger>
							<PopoverContent className="w-auto p-0">
								<Calendar
									mode="single"
									selected={startdate}
									onSelect={setSatrtdate}
									initialFocus
								/>
							</PopoverContent>
						</Popover>

						<Popover>
							<PopoverTrigger asChild>
								<Button
									variant={"outline"}
									className={cn(
										"w-[280px] justify-start text-left font-normal",
										!enddate && "text-muted-foreground",
									)}
								>
									<CalendarIcon className="mr-2 h-4 w-4" />
									{enddate ? (
										format(enddate, "PPP")
									) : (
										<span>End date</span>
									)}
								</Button>
							</PopoverTrigger>
							<PopoverContent className="w-auto p-0">
								<Calendar
									mode="single"
									selected={enddate}
									onSelect={setEndddate}
									initialFocus
								/>
							</PopoverContent>
						</Popover>
						<Button onClick={handleParams}>Search</Button>
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<Table className=" overflow-x-hidden">
						<TableCaption>
							A list of all generated sscc labels.
						</TableCaption>
						<TableHeader>
							<TableRow>
								<TableHead></TableHead>
								<TableHead>Client Name</TableHead>
								<TableHead>Product Name</TableHead>

								<TableHead>Volume</TableHead>
								<TableHead>Tag</TableHead>
								<TableHead className="text-right">
									Date-Generated
								</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{ssccLabelTableLoading && (
								<TableRow>
									<TableCell colSpan={7}>
										<div className="flex justify-center">
											<ClipLoader />
										</div>
									</TableCell>
								</TableRow>
							)}
							{!ssccLabelTableLoading &&
								rows?.map((event) => (
									<TableRow key={event.id}>
										<TableCell>
											<input
												style={{ cursor: "pointer" }}
												type="radio"
												name="sgtinTrace"
												onChange={(e) => {
													setTraceId(event.traceId);
													setSelectedClientId(
														event.clientId,
													);
													setElemTarget(e);
												}}
											/>
										</TableCell>
										<TableCell className=" whitespace-nowrap">
											{event?.clientName}
										</TableCell>
										<TableCell className=" whitespace-nowrap">
											{event?.prodName}
										</TableCell>

										<TableCell>{event?.count}</TableCell>
										<TableCell className=" whitespace-nowrap">
											{event?.tag}
										</TableCell>
										<TableCell className="text-right">
											{handleDate(event?.createdAt)}
										</TableCell>
									</TableRow>
								))}
						</TableBody>
						<TableFooter>
							<TableRow>
								<TableCell colSpan={5}>Total</TableCell>
								<TableCell className="text-right"></TableCell>
							</TableRow>
							<TableRow>
								<TableCell colSpan={5}></TableCell>
								<TableCell>
									{pageCount > 1 && (
										<Paginator
											currentPage={currentPage}
											disabled={ssccLabelTableLoading}
											onPageChange={onPageChange}
											pageCount={pageCount}
										/>
									)}
								</TableCell>
							</TableRow>
						</TableFooter>
					</Table>
				</CardContent>
				<CardFooter></CardFooter>
			</Card>
		</div>
	);
}

export default Sscc;
